export default {"src":"/_next/static/media/tbf_logo.4b3de206.svg","height":54,"width":240,"blurWidth":0,"blurHeight":0};